import React, {Component} from 'react';
import moment from "moment";
import StringUtil from "../../utils/StringUtil";
import {Wizard} from "../../components";
import RemotingService from "../../services/remoting-service/RemotingService";
import ValidationUtil from "../../components/form/validator/ValidationUtil";
import PatientUtil from "../../utils/PatientUtil";
import ConsentFormPartsRad from "./utils/ConsentFormPartsRad";
import FormLanguages from "./enum/FormLanguages";
import InformedConsentHeader from "./informedconsent/InformedConsentHeader";
import InformedConsentSignatureInputs from "./informedconsent/InformedConsentSignatureInputs";
import InformedConsentFormRadTextEnum from "./informedconsent/enum/InformedConsentFormRadTextEnum";
import IntakeFormTextEnum from "./intakeform/enum/IntakeFormTextEnum";
import ClinicLogo from "../../layout/ClinicLogo";

class InformedConsentFormRad extends Component {

    constructor(props) {
        super(props)

        this.state = {
            consentDate: new Date(),
            pregnancyStatus: null,
            modalityType: null,
            genderAcknowledgment: null
        }
    }

    componentDidMount() {
        const {patient, form} = this.props;
        const readOnly = form !== null && form !== undefined;

        RemotingService.getRemoteCall('api/appointment/first-provider/UAE/' + patient.id, {},
            (firstProvider) => {
                if (firstProvider) {
                    this.setState({providerName: firstProvider.name, providerSignature: firstProvider.signature});
                }
            });
    }

    onSubmit = () => {
        if (!ValidationUtil.checkWithNotification(this.formFields)) {
            return;
        }

        if (this.props.form !== null && this.props.form !== undefined) {
            this.props.close();

        } else {
            let patient = this.props.patient;
            let patientFullName = PatientUtil.getPatientName(patient.firstName, patient.middleName, patient.lastName);
            let patientDOB = patient.birthday;
            let patientEId = patient.eid;
            const {
                consentDate,
                providerName,
                guardianName,
                guardianRelationship,
                providerSignature,
                patientSignature,
                pregnancyStatus,
                modalityType,
                genderAcknowledgment,
                witnessName,
                witnessSignature
            } = this.state;

            RemotingService.postRemoteCall('api/patient/' + this.props.patient.id + '/general-info-consent-rad',
                {
                    consentDate, providerName, guardianName,
                    guardianRelationship, providerSignature, patientSignature,
                    patientFullName, patientDOB, patientEId, pregnancyStatus,
                    modalityType, genderAcknowledgment, witnessName, witnessSignature
                },
                (result) => {
                    this.props.afterSave(result);
                    this.props.close();
                });
        }
    }

    onSavePatientSignature = (signature) => {
        this.setState({patientSignature: signature})
    }

    onSaveWitnessSignature = (signature) => {
        this.setState({witnessSignature: signature})
    }

    fieldChanged = (fieldName, value, validationCallback) => {
        this.setState({[fieldName]: value}, () => {
            if (validationCallback) {
                validationCallback(this);
            }
        });
    };

    pushFormFieldRef = (ref) => this.formFields.push(ref);

    render() {
        if (!this.props.show)
            return null;

        let {patient, form, selectedLanguage} = this.props;
        let readOnly = form !== null && form !== undefined;
        let mrnNo = StringUtil.mrn(patient.mrn);
        let patientName = PatientUtil.getPatientName(patient.firstName, patient.middleName, patient.lastName);
        this.formFields = []

        const formBodyClass = selectedLanguage === FormLanguages.ARABIC ? "arabic-form form-body" : "form-body";
        const enumLabel = selectedLanguage === FormLanguages.ARABIC ? "nameInArabic" : "name";
        const commonProps = {
            selectedLanguage: selectedLanguage.name,
            pushFormFieldRef: this.pushFormFieldRef,
            enumLabel: enumLabel,
            readOnly: readOnly
        }

        return (
            <>
                <Wizard
                    show={this.props.show}
                    close={this.props.close}
                    title={InformedConsentFormRadTextEnum.Informed_Consent_Form[selectedLanguage.name]}
                    onSubmit={this.onSubmit}
                    isReadOnly={readOnly}
                    previousBtnText={IntakeFormTextEnum.Wizard_Previous[selectedLanguage.name]}
                    nextBtnText={IntakeFormTextEnum.Wizard_Next[selectedLanguage.name]}
                    saveBtnText={IntakeFormTextEnum.Wizard_Save[selectedLanguage.name]}
                >
                    <Wizard.Page
                        onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                        onPrevious={() => (this.formFields = [])}>
                        <div className={formBodyClass}>
                            <InformedConsentHeader Logo={ClinicLogo} mrnNo={mrnNo} patient={patient} {...commonProps}/>
                            <ConsentFormPartsRad.RadiologyProcedureConsent {...commonProps}/>
                            <ConsentFormPartsRad.ModalityTypeSelection
                                {...commonProps}
                                readOnly={readOnly}
                                modalityType={readOnly ? form?.modalityType : this.state.modalityType}
                                onChange={this.fieldChanged}
                            />
                            <ConsentFormPartsRad.RadiationRiskDeclaration
                                {...commonProps}
                                readOnly={readOnly}
                                pregnancyStatus={readOnly ? form?.pregnancyStatus : this.state.pregnancyStatus}
                                onChange={this.fieldChanged}
                            />
                        </div>
                    </Wizard.Page>

                    <Wizard.Page
                        onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                        onPrevious={() => (this.formFields = [])}>
                        <div className={formBodyClass}>
                            <ConsentFormPartsRad.RemoteRadiologyConsent {...commonProps}/>
                            <ConsentFormPartsRad.DataCollectionAndPrivacy {...commonProps}/>
                            <ConsentFormPartsRad.HealthcareProviderGenderAcknowledgment 
                                {...commonProps}
                                genderAcknowledgment={readOnly ? form?.genderAcknowledgment : this.state.genderAcknowledgment}
                                onGenderAcknowledgmentChange={(value) => this.setState({genderAcknowledgment: value})}
                            />
                        </div>
                    </Wizard.Page>

                    <Wizard.Page
                        onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                        onPrevious={() => (this.formFields = [])}>
                        <div className={formBodyClass}>
                            <ConsentFormPartsRad.PatientRights {...commonProps}/>
                            <ConsentFormPartsRad.QuestionsAndConcerns {...commonProps}/>
                            <ConsentFormPartsRad.Complaints {...commonProps}/>
                        </div>
                    </Wizard.Page>

                    <Wizard.Page
                        onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                        onPrevious={() => (this.formFields = [])}>
                        <div className={formBodyClass}>
                            <ConsentFormPartsRad.FinalConsent {...commonProps}/>

                            <InformedConsentSignatureInputs {...commonProps}
                                                            readOnly={readOnly}
                                                            formFields={this.formFields}
                                                            textEnum={InformedConsentFormRadTextEnum}
                                                            consentDate={moment(readOnly ? new Date(form?.consentDate) : this.state.consentDate).format('LL')}
                                                            patientName={patientName}
                                                            providerName={readOnly ? form?.providerName : this.state.providerName}
                                                            guardianName={readOnly ? form?.guardianName : this.state.guardianName}
                                                            guardianRelationship={readOnly ? form?.guardianRelationship : this.state.guardianRelationship}
                                                            patientSignature={readOnly ? form?.patientSignature : this.state.patientSignature}
                                                            providerSignature={readOnly ? form?.providerSignature : this.state.providerSignature}
                                                            onSavePatientSignature={this.onSavePatientSignature}
                                                            onChange={this.fieldChanged}/>
                        </div>
                    </Wizard.Page>

                    <Wizard.Page 
                        onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                        onPrevious={() => this.formFields = []}>
                        <div style={{width: '1000px'}}>
                            <ConsentFormPartsRad.WitnessStatement 
                                {...commonProps}
                                consentDate={moment(readOnly ? new Date(form?.consentDate) : this.state.consentDate).format('LL')}
                                witnessName={readOnly ? form?.witnessName : this.state.witnessName}
                                witnessSignature={readOnly ? form?.witnessSignature : this.state.witnessSignature}
                                onWitnessNameChange={(val) => this.fieldChanged('witnessName', val)}
                                onWitnessSignatureChange={this.onSaveWitnessSignature}
                                readOnly={readOnly}
                                formFields={this.formFields}
                                pushFormFieldRef={this.pushFormFieldRef}
                            />
                        </div>
                    </Wizard.Page>
                </Wizard>
            </>
        );
    }

}

export default InformedConsentFormRad;